var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8751_27041)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8.66683 14.6673C11.3702 14.662 12.7855 14.596 13.6902 13.6907C14.6668 12.7153 14.6668 11.1433 14.6668 8.00065C14.6668 4.85798 14.6668 3.28665 13.6902 2.30998C12.7142 1.33398 11.1428 1.33398 8.00016 1.33398C4.8575 1.33398 3.28616 1.33398 2.3095 2.30998C1.40483 3.21532 1.33883 4.62998 1.3335 7.33398",
    stroke: "#63382C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 8.0013L11.3333 4.66797M11.3333 4.66797H8.83333M11.3333 4.66797V7.16797",
    stroke: "#63382C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.3335 12.0007C1.3335 10.7433 1.3335 10.1153 1.72416 9.72465C2.11483 9.33398 2.74283 9.33398 4.00016 9.33398C5.2575 9.33398 5.8855 9.33398 6.27616 9.72465C6.66683 10.1153 6.66683 10.7433 6.66683 12.0007C6.66683 13.258 6.66683 13.886 6.27616 14.2767C5.8855 14.6673 5.2575 14.6673 4.00016 14.6673C2.74283 14.6673 2.11483 14.6673 1.72416 14.2767C1.3335 13.886 1.3335 13.258 1.3335 12.0007Z",
    stroke: "#63382C",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8751_27041"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.8cd83bced57f5327c672a1c531ac2c80.svg";
export { ForwardRef as ReactComponent };